export class StringToType {
  public static stringToType<T>(text: string): T {
    return JSON.parse(text) as T;
  }
}
